import { DataGrid } from '@mui/x-data-grid'
import { useState } from 'react'

function ListOperations({ fetchOperations, operations, setSelectedRows }) {
  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)
  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchOperations(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchOperations(url)
  }
  const columns = [
    {
      field: 'Numero',
      headerName: 'No.',
      width: 5,
      editable: false,
    },
    {
      field: 'Description',
      headerName: 'Instruction',
      width: 430,
      flex: 1,
      editable: false,
    },
  ]
  return (
    <div
      style={{
        width: '100% ',
        background: 'unset',
        borderRadius: '5px',
        '.MuiDataGridMain': {
          color: 'white',
        },
      }}
    >
      <DataGrid
        style={{
          color: 'white',
          border: 'unset',
        }}
        sx={{
          height: 750,
          '.MuiDataGrid-cellCheckbox': {
            color: 'white',
          },
          '.MuiDataGrid-cell': {
            borderBottom: 'unset',
            maxHeight: 'fit-content !important',
            minHeight: 'fit-content !important',
            whiteSpace: 'unset !important',
            padding: '10px 0',
          },
          '.MuiCheckbox-root': {
            color: 'white',
          },
          '.Mui-checked': {
            color: 'white !important',
          },
          '.MuiDataGrid-row': {
            maxHeight: 'fit-content !important',
            minHeight: 'fit-content !important',
          },
        }}
        rows={operations.results ? operations.results : []}
        columns={columns}
        pageSize={rows}
        rowCount={operations.count ? operations.count : 0}
        onPageSizeChange={handleRowsChange}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40, 80, 100]}
        pagination
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        checkboxSelection
        disableSelectionOnClick
        hideFooter
        hideFooterPagination
        disableColumnMenu
        columnHeaderHeight={0}
      />
    </div>
  )
}
export default ListOperations
